import {GAME_STATE} from "utils";
import LandingScreen from "./LandingScreen";

const queryParams = new URLSearchParams(window.location.search);
const runMode = queryParams.get("mode");

export default function SeoulDigitechgo({gameState, redbrickEventProjectKey}) {
  return (
    <>{runMode === "play" && gameState === GAME_STATE.LOADING && <LandingScreen redbrickEventProjectKey={redbrickEventProjectKey} />}</>
  );
}
